import { Link } from 'react-router-dom';
import AdminNavigation from '@/components/AdminNavigation';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import TwoFactorSettings from '@/components/TwoFactorSettings';

export default function AdminSecurity() {
  return (
    <div className="min-h-screen bg-slate-50 flex">
      <AdminNavigation />
      <main className="flex-1 p-4 lg:p-8 overflow-x-hidden">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-1">
            <Link to="/admin/settings">
              <Button variant="ghost" size="sm" className="h-8 px-2 text-slate-500">
                <ArrowLeft className="w-4 h-4 mr-1" />Innstillingar
              </Button>
            </Link>
          </div>
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-slate-900">Sikkerheit</h1>
            <p className="text-sm text-slate-500 mt-1">To-faktor autentisering og kontosikkerheit</p>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-5">
            <TwoFactorSettings />
          </div>
        </div>
      </main>
    </div>
  );
}
